import React, { ReactElement, useState, useEffect } from 'react';
import './Main.scss';

import { Link } from 'react-router-dom';

import Register from '../../components/register/Register';
import { useTranslation } from 'react-i18next';
import ExamplesImg from '../../assets/images/example_group.png';
import ExamplesImgRu from '../../assets/images/example_group_ru.png';
import Pic1 from '../../assets/images/SU2026_generaator_Alika.jpg';
import Pic2 from '../../assets/images/SU2026_generaator_Anne.jpg';
import Pic3 from '../../assets/images/SU2026_generaator_Ivo.jpg';
import Pic4 from '../../assets/images/SU2026_generaator_Kristel.jpg';
import Pic5 from '../../assets/images/SU2026_generaator_Mihkel.jpg';
import Pic6 from '../../assets/images/SU2026_generaator_Tanja.jpg';

import { changeLanguage } from 'i18next';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const Main: React.FC = (): ReactElement => {
  type ExampleType = typeof ExamplesImg | typeof ExamplesImgRu;

  const { t, i18n } = useTranslation();

  const getLanguage = () => i18n.language || window.localStorage.i18nextLng;

  const switchLang = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const [ExampleGroup, setExampleGroup] = useState<ExampleType>(ExamplesImg);

  useEffect(() => {
    setTimeout(function () {
      switch (getLanguage()) {
        case 'et':
          setExampleGroup(ExamplesImg);
          break;
        case 'ru':
          setExampleGroup(ExamplesImgRu);
          break;
        default:
          setExampleGroup(ExamplesImg);
          break;
      }
    }, 100);
  }, []);

  return (
    <div className="Main">
      <span className="lang-switcher">
        <button
          onClick={() => {
            changeLanguage('et');
            setExampleGroup(ExamplesImg);
          }}
        >
          EST
        </button>{' '}
        /{' '}
        <button
          onClick={() => {
            changeLanguage('ru');
            setExampleGroup(ExamplesImgRu);
          }}
        >
          RUS
        </button>
      </span>
      <section className="banner">
        <div className="banner-margins">
          <div className={'columns ' + getLanguage()}>
            <div className={'column text-col ' + getLanguage()}>
              <div className="heading">
                <h1 className="bold">{t('header.1')}</h1>
                <h1 className="bolder">{t('header.2')}</h1>
              </div>
              <div className="banner-text">
                <p>{t('banner text.1')}</p>
                {/* <p>{t('banner text.2')}</p> */}
                <p className="bold padded">{t('banner text.3')}</p>
                <Link className="bold" to="#reg-anchor">
                  {t('banner text.4')}
                </Link>
              </div>
              <div className={'ending ' + getLanguage()}>
                <p>
                  {t('banner text.end')}
                  <a href="https://soeluuring.ee">{t('banner text.link')}</a>
                </p>
              </div>
            </div>
            {/* old layout */}
            <div className={'column img-col ' + getLanguage()}>
              <img src={ExampleGroup} alt="" />
            </div>
          </div>
          <div className={'img-carousel ' + getLanguage()}>
            <Carousel
              additionalTransfrom={0}
              customTransition="all 9000ms linear"
              transitionDuration={9000}
              arrows={false}
              autoPlay
              autoPlaySpeed={90}
              centerMode={false}
              className=""
              containerClass="carousel-container"
              itemClass="carousel-item"
              sliderClass="carousel-slider"
              dotListClass=""
              // draggable
              focusOnSelect={false}
              infinite
              // keyBoardControl
              // minimumTouchDrag={80}
              // pauseOnHover
              removeArrowOnDeviceType={['tablet', 'mobile']}
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024,
                  },
                  items: 4,
                  partialVisibilityGutter: 40,
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 2,
                  partialVisibilityGutter: 30,
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464,
                  },
                  items: 3,
                  partialVisibilityGutter: 30,
                },
              }}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots={false}
              slidesToSlide={2}
              // swipeable
            >
              <img src={Pic1} alt="" />
              <img src={Pic2} alt="" />
              <img src={Pic3} alt="" />
              <img src={Pic4} alt="" />
              <img src={Pic5} alt="" />
              <img src={Pic6} alt="" />
            </Carousel>
          </div>
          <div className="columns">
            <div className="column text-col">
              <div className={'separate-ending ' + getLanguage()}>
                <p>
                  {t('banner text.end')}
                  <a href="https://soeluuring.ee">{t('banner text.link')}</a>
                </p>
              </div>
            </div>
          </div>
          <div className="cta">
            <span>{t('cta')}</span>
          </div>
        </div>
      </section>
      <span id="reg-anchor"></span>
      <Register />
    </div>
  );
};

export default Main;
